import { Modal } from '../components/splide'

const listOfModals = [
  'suggest-activity',
  'modal-cancel-spei',
  'modal-success-spei'
]

const clearCookies = () => {
  listOfModals.forEach((modal) => {
    document.cookie = `modal-${modal}=1; expires=Thu, 18 Dec 2013 12:00:00 UTC`
  })
}

const setCookiePolicy = (modal) => {
  let expiryDate = new Date()
  expiryDate.setMonth(expiryDate.getMonth() + 11)

  document.cookie = `modal-${modal}=1; expires=${expiryDate.toGMTString()}`
}

const modals = () => {
  // clearCookies()

  const cookies = document.cookie.split(";")

  listOfModals.forEach((modal) => {
    if (cookies.indexOf(`modal-${modal}=1`) < 0 && cookies.indexOf(` modal-${modal}=1`) < 0) {
      $.fancybox.open($(`#modal-${modal}`), {
        afterShow: () => {
          Modal()
        },
        afterClose: () => {
          setCookiePolicy(modal)
        }
      })
    }
  })
}
export default modals
